import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { hapticSelection } from "@/utils/haptics";

interface UseGestureNavigationOptions {
  enabled?: boolean;
  swipeThreshold?: number;
}

export function useGestureNavigation({ 
  enabled = true,
  swipeThreshold = 100 
}: UseGestureNavigationOptions = {}) {
  const navigate = useNavigate();
  const startX = useRef(0);
  const startY = useRef(0);

  useEffect(() => {
    if (!enabled) return;

    const handleTouchStart = (e: TouchEvent) => {
      startX.current = e.touches[0].clientX;
      startY.current = e.touches[0].clientY;
    };

    const handleTouchEnd = (e: TouchEvent) => {
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      
      const deltaX = endX - startX.current;
      const deltaY = endY - startY.current;
      
      // Only trigger if horizontal swipe is dominant
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipeThreshold) {
        // Swipe right (back navigation)
        if (deltaX > 0 && startX.current < 50) { // Only from left edge
          hapticSelection();
          navigate(-1);
        }
      }
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [enabled, navigate, swipeThreshold]);
}
